module.exports = __webpack_public_path__ + "a25b91d4c51a2a347a16a29250ae9757.png";